<style lang="less">
    .answer{
        position: absolute;
        z-index: 3;
    }
    .answer .art_text_con{
        width:100%;
        height:auto;
        background: #78D3FF;
        border:2px solid #1D2088;
        box-shadow:0px .08rem .02rem 0px rgba(0, 0, 0, 0.3);
        border-radius: .1rem;
        padding:.6rem .2rem .2rem;
        z-index: 9;
        >img{
            width:100%;
            height:auto;
            display: block;
        }
        .art_inner{
            width:100%;
            background:#FFFDE4;
            padding:.2rem .4rem 0;
            >div{
                width:100%;
                height:100%;
                // overflow-x: hidden;
                overflow-y: auto;
                >img{
                    width:100%;
                    height:auto;
                    display: block;
                    margin-bottom: .4rem;
                }
            }
        }
    }
    .answer .play_trast_con{
        width:100%;
        height:auto;
        min-height: 4.8rem;
        padding:0 0.8rem .4rem;
        background:url("../assets/images/blackboard-phone.png") no-repeat;
        background-size:100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        p{
            font-size: .32rem;
            color:#fff;
        }
        .res_right,.res_wrong{
            width:100%;
            height:3rem;
            font-size: .8rem;
            text-align: center;
            color:#fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }
    .answer .res_wrong{
        >div{
            width:2rem;
            height:auto;
            img{
                width:100%;
                height:auto;
                display: block;
                margin-top: .5rem;
                margin-bottom: -.5rem;
            }
        }
    }
    .answer .tra_bottom{
        width:100%;
        margin:.4rem auto 0;
        padding:0 .6rem .2rem;
        .opts{
            width:100%;
            border:1px solid #000;
            border-radius: .1rem;
            padding:.35rem;
            background:#fff;
            .opt_item{
                width:100%;
                padding-bottom: .2rem;
                font-size: .32rem;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .opt_clr{
                    width:.46rem;
                    height:.46rem;
                    margin-right:.3rem;
                    border-radius: 50%;
                    border:.01rem solid #000;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                // .opt_clr.red.active{
                //     background:red;
                // }
                // .opt_clr.yellow.active{
                //     background:#F8C80E;
                // }
                // .opt_clr.green.active{
                //     background:#9DAD30;
                // }
                // .opt_clr.blue.active{
                //     background:#0080CB;
                // }
                .opt_clr:before{
                    content:'';
                    display: block;
                    width:.28rem;
                    height:.28rem;
                    border-radius: 50%;
                }
                .opt_clr.active:before{
                    border:.01rem solid #000;
                    background: #FF0000;
                }
                // .opt_clr.yellow:before{
                //     background: #F8C80E;
                // }
                // .opt_clr.green:before{
                //     background: #9DAD30;
                // }
                // .opt_clr.blue:before{
                //     background: #0080CB;
                // }
                /*.opt_clr.red.active:before,
                .opt_clr.yellow.active:before,
                .opt_clr.green.active:before,
                .opt_clr.blue.active:before{
                    border:none;
                }*/
            }
            .opt_item:last-child{
                padding-bottom: 0;
            }
        }
    }
</style>
<template>
    <div class="answer" @touchmove.prevent>
        <div class="pd">
            <div class="art_text_con"><!-- 蓝底 padding -->
                <img src="../assets/images/up-article-phone.png" alt="">
                <div class="art_inner"><!-- 黄底 padding -->
                    <div>
                        <div class="play_trast_con">
                            <p v-if="status == 'content'">{{gameData.question}}</p>
                            <div v-else-if="status == 'right'" class="res_right">
                                <span>答對了！</span>
                            </div>
                            <div v-else-if="status == 'wrong'" class="res_wrong">
                                <span>答錯了</span>
                                <div @click.stop="init"><img src="../assets/images/play-again-pc.png" alt=""></div>
                            </div>
                        </div>
                    </div>
                    <div class="tra_bottom">
                        <div class="opts">
                            <div class="opt_item" v-for="(item,index) in gameData.opts" :key="index" @click="choiceAnswer(item,index)">
                                <div :class="['opt_clr',item.color,choiced===index?'active':'']"></div>
                                <span>{{item.text}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="../assets/images/down-article-phone.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        gameData:{
            type:Object,
            default:{},
        },
        game_id:{
            type:String,
            default:'0',
        },
        date:{
            type:String,
            default:'',
        },
        push_id:{
            type:String,
            default:'',
        },
    },
    data(){
        return {
            choiced:'',
            status:'content',
        }
    },
    mounted(){
        console.log('answer',this.game_id);
    },
    methods:{
        init(){
            this.choiced = '';
            this.status = 'content';
        },
        choiceAnswer(item,index){
            if(this.choiced!==''){
                return;
            }
            let vm = this;
            this.choiced = index;
            this.$http.get(this.baseUrl+'/Game/answerPush/GaID/'+this.game_id+ '/SrtSet/'+this.gameData.opts[this.choiced].id+"/SrtTime/"+ 5 + '/pushdate/'+ this.date +"/sn/"+ Math.random()).then(res=>{
                    console.log(res)
                    if(res.data == 'pass'){
                        vm.status = 'right';
                        setTimeout(()=>{
                            vm.$emit('next');
                        },3000)
                    }else{
                        vm.status = 'wrong';
                    }
                })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/game-answer.vue